import React, { useEffect } from "react";
import { Tooltip } from "@mui/material";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { TooltipProps } from "./types";

import "./styles.scss";
import { Instance } from "@popperjs/core";

export default function InfoTooltip(props: TooltipProps): React.JSX.Element {
  const [open, setOpen] = React.useState(false);

  const classNameBase = "scd-tooltip";

  const componentTooltipProps = {
    classes: {
      tooltip: "tooltip",
      root: `${classNameBase}-wrapper`,
      rootSm: `${classNameBase}-wrapper-sm`,
      disabled: `${classNameBase}-disabled`,
      required: `${classNameBase}-required`,
      dimension: props.dimension
        ? `${classNameBase}-${props.dimension}`
        : "scd-tooltip-small",
    },
    title: props.title,
    placement: props.placement,
  };

  useEffect(() => {
    if (props.outerClose) {
      setOpen(false);
      props.onOuterClose();
    }
  }, [props.outerClose, props]);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const addPopperDimension = (popperReference: Instance) => {
    if (popperReference?.state.elements.popper) {
      popperReference.state.elements.popper.className += ` ${componentTooltipProps.classes.dimension}`;
    }
  };

  return (
    <div className="scd-info-tooltip">
      <div
        className={
          props.smallIcon === false || props.smallIcon === undefined
            ? componentTooltipProps.classes.root
            : componentTooltipProps.classes.rootSm
        }
      >
        <ClickAwayListener onClickAway={handleTooltipClose}>
          <Tooltip
            disableFocusListener
            disableHoverListener
            disableTouchListener
            open={open}
            onClick={handleTooltipOpen}
            placement={componentTooltipProps.placement}
            title={componentTooltipProps.title}
            slotProps={{
              popper: {
                disablePortal: false,
                popperRef: addPopperDimension,
              },
            }}
          >
            {props.children}
          </Tooltip>
        </ClickAwayListener>
      </div>
    </div>
  );
}
